module.exports = __webpack_public_path__ + "img/dj.f4cf244e.png";